"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
/**
 * Returns the mailbox junk email configuration object which is observable
 */
function getMailboxJunkEmailConfiguration() {
    return store_1.default.mailboxJunkEmailConfiguration;
}
exports.default = getMailboxJunkEmailConfiguration;
//# sourceMappingURL=getMailboxJunkEmailConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-junkmail-configuration/lib/utils/getMailboxJunkEmailConfiguration.js
// module id = 5022
// module chunks = 2